import { CheckCircleOutlined, ClockCircleOutlined, CloseCircleOutlined } from '@ant-design/icons'
import { Row } from 'antd'
import NotStarted from '../../svgs/notStarted'

export enum EApplication {
  ISMS = 'ISMS',
}

export enum EResource {
  AOI = 'AOI',
  SITE = 'SITE',
}

export enum EResourceStatus {
  NOT_STARTED = 'NOT_STARTED',
  IN_PROGRESS = 'IN_PROGRESS',
  SUCCESS = 'SUCCESS',
  FAILURE = 'FAILURE',
}

// export enum EResourceStage {
//   IMAGE_PROCUREMENT_START = 'Image Procurement Started',
//   IMAGE_PROCUREMENT_IN_PROGRESS = 'Image Procurement In Progress',
//   IMAGE_PROCUREMENT_COMPLETE = 'Image Procurement Completed',
//   IMAGE_PROCESSING_START = 'Image Processing Started',
//   IMAGE_PROCESSING_IN_PROGRESS = 'Image Processing In Progress',
//   IMAGE_PROCESSING_COMPLETE = 'Image Processing Completed',
//   GIS_PROCESSING_START = 'GIS Processing Started',
//   GIS_PROCESSING_IN_PROGRESS = 'GIS Processing In Progress',
//   GIS_PROCESSING_COMPLETE = 'GIS Processing Completed',
//   ECOLOGY_VERIFICATION_START = 'Ecology Verification Started',
//   ECOLOGY_VERIFICATION_IN_PROGRESS = 'Ecology Verification In Progress',
//   ECOLOGY_VERIFICATION_COMPLETE = 'Ecology Verification Completed',
//   INGESTED_IN_UAT = 'Site Ingested in UAT',
//   INGESTED_IN_PROD = 'Site Ingested in PROD',
// }

export enum EResourceStage {
  PRE_PROCESSING = 'PRE_PROCESSING',
  VALIDATION = 'VALIDATION',
  PROCESSING = 'PROCESSING',
  UPLOAD = 'UPLOAD',
}

export const resourceStatusIcons = {
  [EResourceStatus.SUCCESS]: (
    <CheckCircleOutlined
      className="status-icon status-success"
      style={{
        fontSize: 24,
        verticalAlign: 'middle',
      }}
    />
  ),
  [EResourceStatus.FAILURE]: (
    <CloseCircleOutlined
      className="status-icon status-failed"
      style={{
        fontSize: 24,
        verticalAlign: 'middle',
      }}
    />
  ),
  [EResourceStatus.IN_PROGRESS]: (
    <ClockCircleOutlined
      className="status-icon status-progress"
      style={{
        fontSize: 24,
        verticalAlign: 'middle',
      }}
    />
  ),
  [EResourceStatus.NOT_STARTED]: (
    <Row align="middle" style={{ width: 24, height: 24 }}>
      <NotStarted color="var(--icon-muted, #8c8c8c)" />
    </Row>
  ),
}

export const noneDropdownItem = {
  value: null,
  label: 'None',
}
